import { render, staticRenderFns } from "./ProductionDashboard.vue?vue&type=template&id=fb9354d6&scoped=true&"
import script from "./ProductionDashboard.vue?vue&type=script&lang=js&"
export * from "./ProductionDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ProductionDashboard.vue?vue&type=style&index=0&id=fb9354d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9354d6",
  null
  
)

export default component.exports